import { useParams, Link, useNavigate } from 'react-router-dom';
import { blogPosts, getCategoryColor } from '../../data/blogPosts';
import styles from './BlogPost.module.css';

const BlogPost = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const post = blogPosts.find(p => p.slug === slug);

  if (!post) {
    return (
      <main className={styles.main}>
        <div className={styles.container}>
          <div className={styles.notFound}>
            <h1>Post not found</h1>
            <Link to="/blog" className={styles.backBtn}>← Back to Blog</Link>
          </div>
        </div>
      </main>
    );
  }

  const categoryColors = getCategoryColor(post.category);

  return (
    <main className={styles.main}>
      <div className={styles.container}>

        {/* ── Back button ── */}
        <button className={styles.backBtn} onClick={() => navigate('/blog')}>
          <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
            <path d="M16 10H4M10 4l-6 6 6 6" stroke="currentColor" strokeWidth="1.8"
                  strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Back to Blog
        </button>

        <article className={styles.article}>
          {/* ── Header ── */}
          <header className={styles.header}>
            <div className={styles.meta}>
              <span
                className={styles.category}
                style={{ background: categoryColors.bg, color: categoryColors.text }}
              >
                {post.category}
              </span>
              <span className={styles.readingTime}>{post.readingTime}</span>
              <time className={styles.date}>{post.date}</time>
            </div>

            <h1 className={styles.title}>{post.title}</h1>

            <p className={styles.excerpt}>{post.excerpt}</p>

            {/* ── Author ── */}
            <div className={styles.authorRow}>
              <div
                className={styles.avatar}
                style={{ background: `${post.author.color}20`, color: post.author.color }}
              >
                {post.author.initials}
              </div>
              <div>
                <div className={styles.authorName}>{post.author.name}</div>
                <div className={styles.authorMeta}>
                  {post.author.field} · {post.author.university}
                </div>
              </div>
            </div>
          </header>

          {/* ── Divider ── */}
          <div className={styles.divider} />

          {/* ── Article body ── */}
          <div className={styles.body}>
            {post.fullContent.split('\n\n').map((paragraph, i) => (
              <p key={i}>{paragraph}</p>
            ))}
          </div>

          {/* ── Tags ── */}
          {post.tags && (
            <div className={styles.tags}>
              {post.tags.map(tag => (
                <span key={tag} className={styles.tag}>{tag}</span>
              ))}
            </div>
          )}
        </article>

        {/* ── Bottom navigation ── */}
        <div className={styles.footer}>
          <button className={styles.backBtn} onClick={() => navigate('/blog')}>
            <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
              <path d="M16 10H4M10 4l-6 6 6 6" stroke="currentColor" strokeWidth="1.8"
                    strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Back to Blog
          </button>
          <Link to="/signup" className={styles.ctaBtn}>
            Start your own research story
            <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
              <path d="M4 10h12M10 4l6 6-6 6" stroke="currentColor" strokeWidth="1.8"
                    strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </Link>
        </div>

      </div>
    </main>
  );
};

export default BlogPost;
